import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AuthModule } from "./auth/auth.module";
import { HomeComponent } from './pages/home/home.component';
import { CoreModule } from "./core/core.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from "./shared/shared.module";
import { QrcodeComponent } from './pages/qrcode/qrcode.component';
import { VerifyComponent } from './pages/verify/verify.component';
import { QRCodeModule } from 'angular2-qrcode';
import { OrderComponent } from './pages/order/order.component';
import { DataTablesModule } from 'angular-datatables';
import { FinanceComponent } from './pages/finance/finance.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { VerifyfailComponent } from './pages/verifyfail/verifyfail.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FreshchatService } from './core/services/fresh-chat.service'
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    QrcodeComponent,
    VerifyComponent,
    OrderComponent,
    FinanceComponent,
    HeaderComponent,
    FooterComponent,
    VerifyfailComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    DataTablesModule,
    NgxPaginationModule,
    QRCodeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    CoreModule,
    AuthModule,
    SharedModule,
  ],
  providers: [FreshchatService,
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
